export default __webpack_public_path__ + "static/media/SSL.a4cee1a2.svg";